import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@/store';
import { Box, CardBody, CardHeader, Flex, VStack } from '@chakra-ui/react';
import { CheckCircleIcon } from '@chakra-ui/icons';
import { Loader, SelectableCard } from '@netiva/classifieds-ui';
import { useAdContactPersons } from '@/pages/Ad/hooks/useContactPersons';
import { AddressLine } from '../AddressSelector/components';
import { ContactPersonRec } from '@netiva/classifieds-api';
import { adActions } from '@/store/ad';

export const ContactPersonSelector: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const { contactPersonIds: assignedContactPersonIds } = useAppSelector((state) => state.ad);
  const { contactPersons, isLoading } = useAdContactPersons();

  const handleSelect = (contactPerson: ContactPersonRec) => {
    let newContactPersonIds: number[];
    if (assignedContactPersonIds.includes(contactPerson.id)) {
      newContactPersonIds = assignedContactPersonIds.filter((id) => id !== contactPerson.id);
    } else {
      newContactPersonIds = [...assignedContactPersonIds, contactPerson.id];
    }
    dispatch(
      adActions.setContactPersonIds(newContactPersonIds.filter((id) => contactPersons.some((cp) => cp.id === id)))
    );
  };

  return (
    <>
      {contactPersons.length > 0 && (
        <>
          <Loader isLoading={isLoading} />

          <Box marginTop={8}>
            {t('ad.steps.address.chooseContactPerson')}
            <Flex gap={4} wrap="wrap" marginTop={5}>
              {contactPersons.map((contactPerson) => (
                <SelectableCard
                  key={contactPerson.id}
                  isSelected={assignedContactPersonIds.includes(contactPerson.id)}
                  onClick={() => handleSelect(contactPerson)}
                  width={{ base: 'full', sm: 'auto' }}
                  minWidth="200px"
                  maxWidth={{ base: 'full', md: '300px' }}
                >
                  <CardHeader padding={2}>
                    {assignedContactPersonIds.includes(contactPerson.id) && (
                      <CheckCircleIcon position="absolute" top={2} right={2} />
                    )}
                  </CardHeader>
                  <CardBody padding={0}>
                    <Flex>
                      <VStack align="stretch" spacing={0} flexShrink={1} overflow="hidden">
                        <AddressLine content={contactPerson.role} />
                        <AddressLine content={[contactPerson.firstname, contactPerson.lastname]} />
                        <AddressLine content={contactPerson.phone} />
                        <AddressLine content={contactPerson.mobile} />
                        <AddressLine content={contactPerson.email} />
                      </VStack>
                    </Flex>
                  </CardBody>
                </SelectableCard>
              ))}
            </Flex>
          </Box>
        </>
      )}
    </>
  );
};
